import { useState, useCallback, useEffect } from 'react';
import { ZoomClient } from '../../../index-types';
export function useVideoAspect(zmClient: ZoomClient) {
  const [aspectRatio, setAspectRatio] = useState<Record<string, number>>({});
  const onVideoAspectRatioChange = useCallback((payload: any) => {
    const { userId, aspectRatio } = payload;
    console.log('video-aspect-ratio-change', payload);
    setAspectRatio((s) => {
      return { ...s, [`${userId}`]: aspectRatio };
    });
  }, []);
  useEffect(() => {
    if (!zmClient || typeof zmClient.on !== 'function') {
      // debug: zmClient not ready yet
      console.warn('useVideoAspect: zmClient not available to subscribe');
      return;
    }

    zmClient.on('video-aspect-ratio-change', onVideoAspectRatioChange);
    return () => {
      zmClient.off('video-aspect-ratio-change', onVideoAspectRatioChange);
    };
  }, [zmClient, onVideoAspectRatioChange]);
  return aspectRatio;
}
